var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"corner-ribbon",class:_vm.classes,attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }